import React from 'react';
import ReactDOM from 'react-dom';
import Layout from './components/common/Layout';
import './index.css';
import SettingsStore from './components/weather/settings_store';
import SettingsActions from './components/weather/settings_actions';
import * as Sentry from '@sentry/browser';

// Initiate Sentry SDK
Sentry.init({
 dsn: "https://557c75513bdb431592ee4d4eb4642e75@sentry.io/1308828",
});
/* eslint no-undef:0 */

window.pollfishConfig = {
  api_key: "7454acc3-0e44-451f-adf3-23693679b41c",
  debug: true,
  // we pass a specific user id since
  // we do not want to answer demographic questions for debug mode
  user_id: "12345",
  request_uuid: "123123", //optional
  ready: pollfishReady, //optional
  closeCallback: surveyClosed, //optional
  userRejectedSurvey: userRejectedSurvey, //optional
  userNotEligibleCallback: userNotEligible, //optional
  closeAndNoShowCallback: closeAndNoShow, //optional
  surveyCompletedCallback: surveyFinished, //optional
  surveyAvailable: surveyAvailable, // optional
  surveyNotAvailable: surveyNotAvailable // optional
};

function surveyClosed(){
  console.log("user closed the survey");

  if(!SettingsStore.settings.get('surveyFinished') &&
    SettingsStore.settings.get('integration') !== 'rewarded' &&
    SettingsStore.settings.get('integration') !== 'offerwall'){
    Pollfish.showIndicator();
  }

}

function userRejectedSurvey(){
  console.log("user rejected this survey by clicking no thanks or rejecting GDPR");
  SettingsActions.set('showWeatherDetails', false);
  // It will remove the unlock feature button when user rejects survey. 
  // Might cause bugs since integration property doesn't handle null values. Revisit if needed.
  SettingsActions.set('integration', null);
}

function userNotEligible(){
  console.log("user is not eligible");
  // we dont want to disqualify a user because of a single user not eligible.
  // The user might be able to respond to more than one surveys and get a success
  if (SettingsStore.settings.get('integration') !== 'offerwall') {
    SettingsActions.set('userNotEligible', true);
    SettingsActions.set('surveyFinished', true);
  }
}

function surveyFinished(){
  console.log("user finished the survey");
  SettingsActions.set('surveyFinished', true);
  SettingsActions.set('showWeatherDetails', true);
}

function closeAndNoShow(){
  console.log("close and no show the survey");
}

function surveyAvailable(data){
  console.log("pollfish survey is available with revenue: " + data.revenue + " and survey format playful: " + data.playful);
}

function surveyNotAvailable() {
  console.log("survey not available");
}

function pollfishReady(){
  SettingsActions.set('surveyFinished', false);
  SettingsActions.set('userNotEligible', false);
  const integration = SettingsStore.settings.get('integration');
  //Pollfish Webplugin is ready, so you can call it excplicitly using the Pollfish.showIndicator or Pollfish.showFullSurvey functions
  if (integration !== 'rewarded' && integration !== 'offerwall') {
    Pollfish.showIndicator();
  }
  $('#hideSurvey').show();
}
ReactDOM.render(
  <Layout />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js